import { BaseApi } from '@shared/config';
import type { GetScheduleWorkRequest, GetScheduleWorksResponse } from './types';

class ScheduleWorkApi extends BaseApi {
  getScheduleWorks = (
    params: GetScheduleWorkRequest
  ): Promise<GetScheduleWorksResponse> => {
    return this.instance.get('/schedule-works', { params });
  };
}

export const scheduleWorkApi = new ScheduleWorkApi();
